import sortBy from 'lodash/sortBy';
import get from 'lodash/get';
import createConsts from '../../utils/redux/consts';
import { createActions } from '../../utils/redux';

const supportedActions = [
  'ADD_COMMENT',
  'LOAD_COMMENTS',
  'LOAD_NEW_COMMENTS',
  'LOAD_OLDER_COMMENTS',
  'UPDATE_COMMENTS_LIST',
  'DELETE_COMMENT',
  'EDIT_COMMENT',
  'CLEAR',
  'EDIT_COMMENT_STATUS',
];

export const consts = createConsts(
  'communities',
  'commentsList',
  ...supportedActions,
);
export const actions = createActions(consts);

const addComment = (state, payload) => {
  const { parentId } = payload;

  if (!parentId) return [payload, ...state];

  // nested comment
  const parentCommentIndex = state.findIndex(item => item.id === parentId);
  const parentComment = state[parentCommentIndex];

  // eslint-disable-next-line no-param-reassign
  delete payload.comments;

  return [
    ...state.slice(0, parentCommentIndex),
    Object.assign({}, parentComment, {
      comments: [...parentComment.comments, payload],
    }),
    ...state.slice(parentCommentIndex + 1),
  ];
};

const doChangeInArray = (array, id, change) => {
  const index = array.findIndex(i => i.id === parseInt(id, 10));

  return [
    ...array.slice(0, index),
    {
      ...array[index],
      ...change,
    },
    ...array.slice(index + 1),
  ];
};

const deleteComment = (state, payload) => {
  const { id, parentId } = payload;

  if (!parentId) {
    return doChangeInArray(state, id, { deleted: true });
  }
  // Nested comment
  const parentComment = state.find(i => i.id === parentId);
  const parentIndex = state.indexOf(parentComment);
  parentComment.comments = doChangeInArray(parentComment.comments, id, {
    deleted: true,
  });

  return [
    ...state.slice(0, parentIndex),
    { ...parentComment },
    ...state.slice(parentIndex + 1),
  ];
};

const editComment = (state, payload) => {
  const { id, parentId, content } = payload;
  const change = { content, updated: true };

  if (!parentId) {
    return doChangeInArray(state, id, change);
  }
  // Nested comment
  const parentComment = state.find(i => i.id === parentId);
  const parentIndex = state.indexOf(parentComment);
  parentComment.comments = doChangeInArray(parentComment.comments, id, change);

  return [
    ...state.slice(0, parentIndex),
    { ...parentComment },
    ...state.slice(parentIndex + 1),
  ];
};

const editCommentStatus = (state, payload) => {
  const { id, parentId, prop } = payload;
  const change = prop;

  if (!parentId) {
    return doChangeInArray(state, id, change);
  }
  // Nested comment
  const parentComment = state.find(i => i.id === parentId);
  const parentIndex = state.indexOf(parentComment);
  parentComment.comments = doChangeInArray(parentComment.comments, id, change);

  return [
    ...state.slice(0, parentIndex),
    { ...parentComment },
    ...state.slice(parentIndex + 1),
  ];
};

const updateCommentsList = (state, payload) => {
  const notifications = [...payload.newComments];
  const { postId } = payload;
  const newState = [...state];
  notifications.forEach(item => {
    const newComment = {
      author: get(item, 'author'),
      createdAt: new Date(get(item, 'createdAt', Date.now())),
      content: get(item, 'content'),
      id: get(item, 'id'),
      isNewComment: get(item, 'isNewComment'),
      postId,
    };

    if (!item.parentId) {
      newComment.comments = [];

      return newState.push(newComment);
    }

    const updatedIndex = newState.findIndex(
      comment => comment.id === item.parentId,
    );
    const replies = newState[updatedIndex].comments;

    newState[updatedIndex].comments = sortBy([...replies, newComment], ['id']);
  });

  return sortBy(newState, ['id']).reverse();
};

export default (state = [], action) => {
  const { payload, type } = action;
  switch (type) {
    case consts.ADD_COMMENT:
      return addComment(state, payload);
    case consts.DELETE_COMMENT:
      return deleteComment(state, payload);
    case consts.LOAD_OLDER_COMMENTS:
      return [...state, ...payload];
    case consts.LOAD_NEW_COMMENTS:
      return [...payload, ...state];
    case consts.LOAD_COMMENTS:
      return payload;
    case consts.UPDATE_COMMENTS_LIST:
      return updateCommentsList(state, payload);
    case consts.EDIT_COMMENT:
      return editComment(state, payload);
    case consts.EDIT_COMMENT_STATUS:
      return editCommentStatus(state, payload);
    case consts.CLEAR:
      return [];
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/communities/commentsList.js